import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MergeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"merge"}/>
}
